<template>
<h1 class="title">
  <span class="icon-text">
    <span class="icon ">
      <img alt="logo" src="@/assets/logo-bat.png">
    </span>
    <span >
      Sign Up
    </span>
  </span>
</h1>
<div class="field">
  <label class="label">Given Name</label>
  <input
    class="input"
    type="text"
    required
    :class="{'is-danger': this.warn && this.warnings && 'given_name' in this.formErrors}"
    @keyup="this.warn = false  ; this.failed = false"
    v-model="given_name" >
</div>
<div class="field">
  <label class="label">Family Name</label>
  <input
    class="input"
    type="text"
    required
    :class="{'is-danger': this.warn && this.warnings && 'family_name' in this.formErrors}"
    @keyup="this.warn = false  ; this.failed = false"
    v-model="family_name" >
</div>
<div class="field">
  <label class="label">Email</label>
  <input
    class="input"
    type="email"
    required
    :class="{'is-danger': this.warn && this.warnings && 'email' in this.formErrors}"
    @keyup="this.warn = false  ; this.failed = false"
    v-model="email" >
</div>
<div class="field">
  <label class="label">Temporary Password</label>
  <input
    class="input"
    type="password"
    required
    :class="{'is-danger': this.warn && this.warnings && 'password_old' in this.formErrors}"
    @keyup="this.warn = false  ; this.failed = false"
    v-model="password_old" >
</div>
<br>
<div class="field">
  <label class="label">
    <p>New Password</p>
    <p class="has-text-weight-light is-italic">8 characters, one symbol, upper, lower case and digit</p>
  </label>
  <input
    class="input"
    type="password"
    placeholder="contains 1 number, upper, lower case, a special character"
    required
    :class="{'is-danger': this.warn && this.warnings && 'password' in this.formErrors}"
    @keyup="this.warn = false  ; this.failed = false"
    v-model="password" >
</div>
<div class="field">
  <label class="label">Repeat New Password</label>
  <input
    class="input"
    type="password"
    required
    :class="{'is-danger': this.warn && this.warnings && 'password_repeat' in this.formErrors}"
    @keyup="this.warn = false  ; this.failed = false"
    v-model="password_repeat" >
</div>
<div class="control py-5">
  <label class="ckeckbox">
    <input
      type="checkbox"
      :class="{'is-danger': this.warn && this.warnings && 'terms' in this.formErrors}"
      @keyup="this.warn = false  ; this.failed = false"
      v-model="terms" >
    <span
      :class="{
          'has-text-weight-bold': this.warn && this.warnings && 'terms' in this.formErrors,
          'has-text-danger': this.warn && this.warnings && 'terms' in this.formErrors
      }" >
      Accept terms and conditions
    </span>
  </label>
</div>
<div class="buttons">
  <button class="button" @click="submitClicked">Submit</button>
</div>
</template>

<script>
import { mapState, mapActions } from 'pinia'
import { useLogin  } from '@/js/auth.js'


function CheckPassword(inputtxt) {
    var paswd = /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/
    return inputtxt.match(paswd)
}  


export default {
    emits: ["submitted"],
    data() {
	return {
	    email: "",
	    password: "",
	    password_repeat: "",
	    password_old: "",
            given_name: "",
            family_name: "",
            terms: false,
            warn: false,
            failed: false,
        }
    },
    created() {
        this.email = this.previous
        if (this.$route.query.email){
            this.email = this.$route.query.email
        }
        if (this.$route.query.old_password){
            this.old_password = this.$route.query.old_password
        }
    },
    methods: {
        submitClicked() {
            if (this.warnings) {
                console.log("SignUp: form contains warnings...")
                this.password = ""
                this.password_repeat = ""
                this.warn = true
 	        return null
 	    } else {
                this.warn = false
            }
 	    const data = {
 	        email: this.email,
 	        password: this.password,
                password_old: this.password_old,
                givenName: this.given_name,
                familyName: this.family_name,
 	    }
            this.$emit("submitted", {stage: "resetpassword", data: data})
        },
    },
    computed: {
        ...mapState(useLogin, {"previous": "email"}),
        formErrors() {
            let state = {}
            if (!this.email.includes(".")){
                let email = {}
                email.error = true
                email.message = "email must contain a `.` symbol"
                state.email = email
            }
            if (!this.email.includes("@")){
                let email = {}
                email.error = true
                email.message = "email must contain a `@` symbol"
                state.email = email
            }
            if (this.email.length < 4){
                let email = {}
                email.error = true
                email.message = "email too short"
                state.email = email
            }
            if (this.password_old.length < 3){
                let password_old = {}
                password_old.error = true
                password_old.message = "old password too short"
                state.password_old = password_old
            }
            if (this.password.length < 8){
                let password_len = {}
                password_len.error = true
                password_len.message = "password too short"
                state.password = password_len
            }
            if (this.password != this.password_repeat){
                let password_rep = {}
                password_rep.error = true
                password_rep.message = "passwords not matching"
                state.password_repeat = password_rep
            }
            if (!CheckPassword(this.password)){
                let password = {}
                password.error = true
                password.message = "new password not sufficiently complex"
                state.password = password
            }
            if (this.given_name.length < 2){
                let given = {}
                given.error = true
                given.message = "given name too short"
                state.given_name = given
            }
            if (this.family_name.length < 2){
                let family = {}
                family.error = true
                family.message = "family name too short"
                state.family_name = family
            }
            if (!this.terms){
                let terms = {}
                terms.error = true
                terms.message = "terms must be accepted"
                state.terms = terms
            }
            return state
        },
        warnings(){
            return Object.keys(this.formErrors).length > 0
        },
    },
}
</script>
